import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=69d00aee"
import script from "./Customer.vue?vue&type=script&lang=ts"
export * from "./Customer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports